module.exports = __webpack_public_path__ + "static/media/Watercolour-100.525bebc8.webp";